import React from 'react';
import { SearchResultContext } from '../../context/SearchResultContext';
import { PaginationButton } from './components/PaginationButton';
import Icon from '../../../icon';

const PaginationBlockMobile = ({ onClickHandler }) => {
	const { results, page, setPage } = React.useContext(SearchResultContext);

	const totalPages = Math.ceil(Number(results.totalItems) / 12);

	const showPrevPageBtn = Number(page) > 1;
	const showNextPageBtn = Number(page) < totalPages;

	const handleScroll = () => {
		const el = document.getElementById('search-result-page-client');
		setTimeout(() => {
			if (el) {
				// Try scrollIntoView first, with fallback to scrollTo
				el.scrollIntoView({ behavior: 'smooth', block: 'start' });
			} else {
				// Fallback to scroll to top if element not found
				window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		}, 250);
	};

	const getPagesToDisplay = (page, totalPages) => {
		let start = Number(page) === 1 ? 1 : Number(page) - 1;

		if (totalPages - Number(page) < 1) start = totalPages - 2;

		return Array.from({ length: totalPages + 1 }, (x, i) => i).slice(
			start,
			start + 3
		);
	};

	const filteredPages =
		totalPages < 3
			? Array.from({ length: totalPages }, (x, i) => i)
			: getPagesToDisplay(Number(page), totalPages);

	if (totalPages <= 1) return <></>;

	return (
		<div className='pagination-block-wrapper-mobile'>
			{/* Previous page button */}
			{showPrevPageBtn && (
				<PaginationButton
					ariaLabel="Previous page"
					onclick={() => {
						handleScroll();
						setPage((Number(page) - 1).toString());
					}}
				>
					<div className='pagination-icon-wrapper'>
						<Icon icon="arrow-left" additionalClasses='pagination-icon' />
					</div>
				</PaginationButton>
			)}
			{/* First button, always '1' */}
			{totalPages > 2 ? (
				<>

					{filteredPages.map((i) => {
						return (
							<PaginationButton
								activeButton={Number(page) === i}
								onclick={() => {
									handleScroll();
									setPage(i.toString());
								}}
								key={i}
							>
								<p className='pagination-button-label'>
									{i}
								</p>
							</PaginationButton>
						);
					})}
				</>
			) : (
				<>
					{Array.from({ length: totalPages }, (x, i) => i).map((i) => {
						return (
							<PaginationButton
								activeButton={Number(page) === i + 1}
								onclick={() => {
									handleScroll();
									setPage((i + 1).toString());
								}}
								key={i}
							>
								<p className='pagination-button-label'>
									{i + 1}
								</p>
							</PaginationButton>
						);
					})}
				</>
			)}
			{/* Next page button */}
			{showNextPageBtn && (
				<PaginationButton
					ariaLabel="Next page"
					onclick={() => {
						handleScroll();
						setPage((Number(page) + 1).toString());
					}}
				>
					<div className='pagination-icon-wrapper'>
						<Icon icon="arrow-right" additionalClasses='pagination-icon' />
					</div>
				</PaginationButton>
			)}
		</div>
	);
};

export { PaginationBlockMobile };
